/**
 * Enum for Features
 * @readonly
 * @enum {string}
 */
const FEATURES = Object.freeze({
    TENANT: 'tenant',
    REGISTER: 'register',
    PAYMENTS: 'payments',
    DASHBOARD: 'dashboard',
    LEVY_ROLL: 'levy-roll',
    DOCUMENTS: 'documents',
    COMPLIANCE: 'compliance',
    MY_PROFILE: 'my-profile',
    BALANCE_SHEET: 'balance-sheet',
    ACCOUNT_HISTORY: 'accounts-history',
    CONTRACTORS_ROLL: 'contractors-roll',
    INCOME_STATEMENT: 'income-statement',
    FINANCIAL_SUMMARY: 'financial-summary',
    CLEARANCE_CAPTURE: 'clearance-capture',
    CLEARANCE_REQUEST:	'clearance-request',
    CASHFLOW_STATEMENT: 'cashflow-statement',
    CASHFLOW_STATEMENT_NEW: 'cashflow-statement-new',
    PERSONAL_DOCUMENTS: 'personal-documents',
    PAYMENT_AUTHORISATION: 'payment-authorisation',
    UTILITY: 'utility',
    DOCUMENTS_APPROVAL:'docs-approval',
    LOGIN:'login',
    HISTORICAL_LINK:'historical-link',
    RENTALS_CAPTURE: 'rentals-capture',
    WAGES_ROLL: 'wages-roll',
    TRUSTEE_DASHBOARD: 'trustee-dashboard',
    INCOME_VS_BUDGET: 'income-vs-budget',
    DEBTOR_AGE_ANALYSIS: 'debtor-age-analysis',
    SHOW_FIND_A_CONTRACTOR: 'find-a-contractor',
    AUDITS_CAPTURE: 'audits-capture',
    AUDITORS_DASHBOARD: 'auditors-dashboard',
    SET_PASSWORD: 'set-password',
});

export default FEATURES;
